import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import classNames from 'classnames';

import { SeasonLeadersCard } from './components/SeasonLeadersCard';
import { SvgIcon } from '../../../../../../common/react/components/SvgIcon';
import { sliderSettings, BREAKPOINTS_FOR_FOUR_SLIDES } from '../../config/slider';
import { seasonLeadersDataSelector } from '../../../../store/js/modules/statspro/season-leaders/selectors/data-selector';
import { FETCH_SEASON_LEADERS } from '../../../../store/js/modules/statspro/season-leaders/actions';

export const SeasonLeadersSlider = ( { seasonId, compseasonId } ) => {
    const dispatch = useDispatch();
    const data = useSelector( seasonLeadersDataSelector );
    const sliderName = 'season-leaders';

    useEffect( () => {
        dispatch( FETCH_SEASON_LEADERS.request( { seasonId } ) );
    }, [] );

    return (
        <div className={ classNames( 'season-leaders__slider stats-slider fade-in-on-load', {
            'is-loaded': !!data?.displayOrder?.length
        } ) }>
            <Swiper { ...sliderSettings( sliderName ) } { ...BREAKPOINTS_FOR_FOUR_SLIDES }>
                { data?.displayOrder?.map( ( category, i ) => (
                    <SwiperSlide key={ i }>
                        <SeasonLeadersCard
                            players={ data[ category ] }
                            compseasonId={ compseasonId }
                        />
                    </SwiperSlide>
                ) ) }
            </Swiper>
            <div className={ `swiper-button-prev swiper-button-prev-unique-${ sliderName }` }>
                <SvgIcon
                    icon="chevron"
                    className="icon"
                />
            </div>
            <div className={ `swiper-button-next swiper-button-next-unique-${ sliderName }` }>
                <SvgIcon
                    icon="chevron"
                    className="icon"
                />
            </div>
        </div>
    );
};

SeasonLeadersSlider.propTypes = {
    seasonId: PropTypes.string.isRequired,
    compseasonId: PropTypes.string.isRequired
};